import React from 'react'
import { Route } from "react-router-dom";
import { Switch } from "react-router-dom";
import { Sidebar } from "semantic-ui-react";
import { Segment } from "semantic-ui-react";
import ConsultationReminderForm from "./ConsultationReminderForm";
import ConsultationRemindersListContainer from "./ConsultationRemindersListContainer";
import ConsultationRemindersMenuContainer from "./ConsultationRemindersMenuContainer";

class ConsultationReminders extends React.Component {

  render () {
    return (
      <div>
        <Switch>
          <Route path={Routes.consultation_reminder_path({ id: ":id", _options: true})} render={ props => (
            <Sidebar.Pushable as={Segment} className= "min-height-90">
              <ConsultationRemindersMenuContainer/>
              <Sidebar.Pusher className="left-sidebar-margin">
                <ConsultationReminderForm entityId={props.match.params.id} />
              </Sidebar.Pusher>
            </Sidebar.Pushable>
          )} />
          <Route path={Routes.consultation_reminders_path()}  render={(props) => <ConsultationRemindersListContainer/> }/>
        </Switch>
      </div>
    )
  }
}

export default ConsultationReminders
